import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin, GraduationCap, Star } from "lucide-react";

export function DestinationCard({ d }) {
  return (
    <Link
      to={`/destinations/${d.slug}`}
      className="group relative block rounded-2xl overflow-hidden h-72 hover-lift"
    >
      <img
        src={d.image}
        alt={d.name}
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#012a1e] via-[#012a1e]/40 to-transparent" />
      <div className="absolute top-4 left-4 w-11 h-11 rounded-full bg-white/95 grid place-items-center text-2xl shadow-lg">
        {d.flag}
      </div>
      <div className="absolute inset-x-0 bottom-0 p-5">
        <div className="flex items-center gap-1.5 text-[#e0c05a] text-xs font-medium">
          <MapPin size={13} /> {d.city}
        </div>
        <h3 className="font-display text-white text-2xl font-bold mt-1">{d.name}</h3>
        <p className="text-white/75 text-sm mt-1.5 line-clamp-2 max-w-xs">{d.blurb}</p>
        <span className="inline-flex items-center gap-1 text-white text-sm font-semibold mt-3 opacity-0 -translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all">
          Explore destination <ArrowUpRight size={16} />
        </span>
      </div>
    </Link>
  );
}

export function UniversityCard({ u }) {
  return (
    <Link
      to={`/universities/${u.slug}`}
      className="group flex flex-col bg-white rounded-2xl overflow-hidden border border-slate-100 hover-lift"
    >
      <div className="relative h-44 overflow-hidden">
        <img
          src={u.image}
          alt={u.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
        {u.featured && (
          <span className="absolute top-3 left-3 flex items-center gap-1 bg-[#c9a227] text-[#013d2b] text-[11px] font-bold px-3 py-1 rounded-full uppercase tracking-wide">
            <Star size={12} className="fill-[#013d2b]" /> Featured Partner
          </span>
        )}
        <span className="absolute bottom-3 left-3 text-white text-sm font-medium flex items-center gap-1.5">
          {u.flag} {u.country}
        </span>
      </div>
      <div className="p-5 flex flex-col flex-1">
        <h3 className="font-display text-xl font-bold text-[#012a1e] leading-snug">{u.name}</h3>
        <p className="text-[#c9a227] text-sm font-semibold mt-1">{u.rank}</p>
        <p className="text-slate-500 text-sm mt-2 line-clamp-2 flex-1">{u.intro}</p>
        <div className="flex flex-wrap gap-1.5 mt-4">
          {u.tags.map((t) => (
            <span key={t} className="text-[11px] font-medium px-2.5 py-1 rounded-full bg-[#f0f6f3] text-[#004030]">
              {t}
            </span>
          ))}
        </div>
        <div className="flex items-center justify-between mt-5 pt-4 border-t border-slate-100">
          <span className="flex items-center gap-1.5 text-sm text-slate-600">
            <GraduationCap size={16} className="text-[#004030]" /> {u.tuition}
          </span>
          <span className="text-[#004030] font-semibold text-sm flex items-center gap-1 group-hover:gap-2 transition-all">
            View <ArrowUpRight size={15} />
          </span>
        </div>
      </div>
    </Link>
  );
}